module.exports = __webpack_public_path__ + "img/06_2_2_1.aa2fe158.png";